<template>
  <div class="mainContent helpContent">
    <pageHead device="desktop" page="about" :title="Title"/>
    <div class="rule container about">
      <h1 class="title lkrule"><span>{{ Title }}</span></h1>
      <section class="rule-cont" v-for="(item, index) in PageList" :key="index">
        <div class="title">{{ item.title }}</div>
        <div class="itemContent" v-html="item.cont"></div>
      </section>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getJsonFile } from '@/utils/jsonFile';
import pageHead from "~/components/common/pageHead.vue";
export default {
  components: { pageHead },
  computed: {
    DEF_webStyle() {
      return process.env.DEF_webStyle || 'default';
    },
    PageList() {
      let list = getJsonFile(process.env.DEF_webStyle, `about_${this.$i18n.locale}`);
      if (this.WebSetting.WEBNAME)
      list[0].title = list[0].title.replace('{WEBNAME}', this.WebSetting.WEBNAME)
      return list
    },
    HasX() {
      return Object.keys(this.$route.query).indexOf('x') >= 0;
    },
    Title() {
      if (this.DEF_webStyle == 'bu88')
        return this.$t("store.help_comp") + (this.HasX ? ' - ' + process.env.WEB_TITLE : '');
      else
        return this.$t("store.about_title01") + (this.HasX ? ' - ' + process.env.WEB_TITLE : '');
    },

    Title() {
      if (this.DEF_webStyle == 'egyy')
        return this.$t("store.help_comp") + (this.HasX ? ' - ' + process.env.WEB_TITLE : '');
      else
        return this.$t("store.about_title01") + (this.HasX ? ' - ' + process.env.WEB_TITLE : '');
    },

    ...mapState(['WebSetting']),
  }
};
/*
  import { mapState } from "vuex";
  import pageHead from "~/components/common/pageHead.vue";
  export default {
    components: { pageHead },
    data() {
      return {
        list: this.handleList(),
        ListT01: this.handleListT01(),
      };
    },
    methods: {
      handleListT01(){
        return [

        ];
      },
      handleList() {
        return [
          {
            title: "",
            cont1: this.$t("store.about_sub01"),
          },
          {
            title: this.$t("store.about_title02"),
            cont1: this.$t("store.about_sub02"),
          },
          {
            title: this.$t("store.about_title03"),
            cont1: this.$t("store.about_sub03_a"),
            cont2: this.$t("store.about_sub03_b"),
            cont3: this.$t("store.about_sub03_c"),
            cont4: this.$t("store.about_sub03_d"),
          },
        ];
      },
      changeLang() {
        this.list = this.handleList();
        this.ListT01 = this.handleListT01();
      },
    },
    mounted: function () {
      if (this.WebSetting.WEBNAME)
        this.list[0].title = this.WebSetting.WEBNAME;
        this.ListT01[0].title = this.WebSetting.WEBNAME;
    },
    watch: {
      "$i18n.locale"(language) {
        this.changeLang();
      },
    },
    computed: {
      DEF_webStyle() {
        return process.env.DEF_webStyle || 'default';
      },
      ...mapState(['WebSetting']),
    },
  };
  */
</script>
